import React, { } from 'react';
import { useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';

import { hasError, ReactHookFormErrorMessage } from 'components/base/ErrorFieldMessage';
import { CustomTitleWithDropDown } from 'components/customer/CustomTitleWithDropDown';
import InputFieldControl from 'components/base/InputFieldControl';

const getLabel = (watchField, labelContainPk, isSku) => {
  if (isSku) {
    return watchField;
  };
  if (labelContainPk) {
    return `[ID: ${watchField?.pk}] ${watchField?.name}`;
  };
  return watchField?.name;
};

export const RequirementBaseDropdown = ({
  title,
  titleStyle,
  isSku = false,
  valueFieldName,
  modelName,
  sourceListName,
  customOnChange = () => { },
  description,
  placeholder,
  dropDownSearchBarPlaceholder,
  formErrorId = valueFieldName,
  defaultFilter = {},
  labelContainPk = true,
  loadMoreAction,
  filterAction,
  isAdditionalData,
  additionalTitle,
  additionalName,
}) => {
  const { watch, formState: { errors }, setValue } = useFormContext();
  const watchField = watch(valueFieldName)
  const defaultValue = {
    value: watchField,
    label: getLabel(watchField, labelContainPk, isSku),
  }
  const { sourceList } = useSelector((state) => ({
    sourceList: state?.[modelName]?.[sourceListName],
  }));

  const onSelectChange = (value) => {
    if (valueFieldName) {
      setValue(valueFieldName, isSku ? value?.value?.name : value?.value || {}, { shouldDirty: true })
    }
    // reset additional data value
    if (isAdditionalData && !value?.value) {
      setValue(additionalName, '', { shouldDirty: true })
    }
    customOnChange(value?.value);
  };

  return (
    <div className='d-flex flex-column' style={{ width: '100%' }}>
      <CustomTitleWithDropDown
        customClass={hasError(errors, formErrorId) ? "error-field" : ""}
        title={title}
        description={description}
        titleStyle={titleStyle}
        defaultValue={(watchField?.pk || isSku) ? defaultValue : { value: null, label: null }}
        placeholder={placeholder}
        dropDownSearchBarPlaceholder={dropDownSearchBarPlaceholder}
        setValue={onSelectChange}
        source={sourceList}
        labelContainPk={labelContainPk}
        loadMoreAction={loadMoreAction}
        needFilter={!isSku}
        filterAction={filterAction}
        defaultFilter={defaultFilter}
      />
      {
        isAdditionalData && watchField?.pk && (
          <InputFieldControl
            name={additionalName}
            useDefaultFieldName
            title={additionalTitle}
            className="coupon-campaign-section-input line-item-group-sku-section"
          />
        )
      }
      <ReactHookFormErrorMessage errors={errors} id={formErrorId} />
    </div>
  )
}


